export default __webpack_public_path__ + "static/feature-importances--mobile-88f8f1e552f9d41430ed6bf9f5581d31.png";